import {Pipe, PipeTransform} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';

@Pipe({
    name: 'filterDetailLine'
})
export class FilterDetailLinePipe implements PipeTransform {

    transform(details: DetaillineDTOModel[], text: string): DetaillineDTOModel[] {
        if (!text || text.length === 0) {
            return details;
        }
        text = text.toLowerCase();

        if (details[0].plu) {
            return details.filter(detail => {
                if (detail.description) {
                    return detail.plu.toLowerCase().includes(text) || 
                           detail.description.toLowerCase().includes(text) || 
                           detail.id.toString().includes(text) ||
                           detail.supplierRef.toLowerCase().includes(text);
                } else {
                    return detail.plu.toLowerCase().includes(text)||
                    detail.supplierRef.toLowerCase().includes(text);
                }

            });
        }
        if (details[0].pdesc) {
            return details.filter(detail => {
                if (detail.reg) {
                    const regTemp = '' + detail.reg;
                    return detail.pdesc.toLowerCase().includes(text) || detail.description.toLowerCase().includes(text) || regTemp.toLowerCase().includes(text);
                } else if (detail.description) {
                    return detail.pdesc.toLowerCase().includes(text) || detail.description.toLowerCase().includes(text);
                } else {
                    return detail.pdesc.toLowerCase().includes(text);
                }
            });
        }
        if (details[0].line && details[0].line.pdesc) {
            return details.filter(detail => {
                console.log(detail);
                if (detail.line.reg) {
                    const regTemp = '' + detail.line.reg;
                    return detail.line.pdesc.toLowerCase().includes(text) || detail.line.description.toLowerCase().includes(text) || regTemp.toLowerCase().includes(text);
                } else if (detail.line.description) {
                    return detail.line.pdesc.toLowerCase().includes(text) || detail.line.description.toLowerCase().includes(text);
                } else {
                    return detail.line.pdesc.toLowerCase().includes(text);
                }
            });
        }

        if (details[0].equipment && details[0].equipment.pdesc) {
            return details.filter(detail => {
                if (detail.equipment.reg) {
                    const regTemp = '' + detail.equipment.reg;
                    return detail.equipment.pdesc.toLowerCase().includes(text) || detail.equipment.description.toLowerCase().includes(text) || regTemp.toLowerCase().includes(text);
                } else if (detail.equipment.description) {
                    return detail.equipment.pdesc.toLowerCase().includes(text) || detail.equipment.description.toLowerCase().includes(text);
                } else {
                    return detail.equipment.pdesc.toLowerCase().includes(text);
                }
            });
        }

    }

}
